module.exports = __webpack_public_path__ + "static/media/email-icon-black.f17a6c59.svg";